/*
  Săgeți pe poza mare din galeria paginii de produs. Stiluri și condiții: snippets/tuju-pdp-galerie.liquid
  (doar pe template-ul implicit și doar la produsele cu cel puțin 2 poze).

  - Câte o pereche de săgeți în fiecare galerie a secțiunii: below-mobile (slider, sub 960 px) și above-mobile (desktop).
  - Slider (mobil): săgeata derulează slider-ul la poza vecină, ca un swipe. Merge și înainte să se încarce theme.js
    (tema îl încarcă la prima interacțiune); când tema e gata, ascultătorii ei de swipe sincronizează miniatura activă,
    înălțimea și pauza video.
  - Desktop: săgeata apasă miniatura vecină (data-product-thumbnail), deci comutarea pozei rămâne logica temei.
  - Poza curentă: ținta ultimei săgeți cât timp slider-ul încă derulează (ca tap-urile rapide să nu se piardă), apoi
    slide-ul aliniat la stânga; pe desktop, poza vizibilă. Se compară după id-ul media. După ultima poză urmează prima.
  - Miniatura țintă e adusă în banda de miniaturi (doar orizontal, pagina nu se mișcă): tema derulează banda doar la
    schimbarea variantei, iar la produsele cu multe poze miniatura activă ar ieși din vedere.
  - Contorul „1 / N” (doar slider-ul de pe mobil; pe desktop îl ascunde CSS-ul) urmează poza curentă, și la swipe.
  - Badge-ul campaniei: conținutul din <template data-tuju-gal-badges> (randat de tuju-campaigns, cu clasele
    tuju-cmp--<id>, deci gate-ul de expirare îl ascunde ca pe celelalte) se pune peste poză, în fiecare galerie.
  - Dacă tema înlocuiește galeria (media grupată pe variante), săgețile, contorul și badge-ul se pun din nou.
*/
(function () {
  var script = document.currentScript;
  var section = script && document.querySelector(script.dataset.root);
  if (!section || section.__tujuGal) return;
  section.__tujuGal = true;

  var PENDING_MS = 700;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function thumbsOf(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumbnail]'));
  }

  function sliderOf(gallery) {
    return gallery.classList.contains('below-mobile') ? gallery.querySelector('.scroll-slider__slider') : null;
  }

  function slideById(slider, id) {
    return Array.prototype.filter.call(slider.querySelectorAll('[data-media-item-id]'), function (slide) {
      return slide.getAttribute('data-media-item-id') === id;
    })[0];
  }

  function currentMediaId(gallery) {
    var pending = gallery.__tujuPending;
    if (pending && Date.now() < pending.until) return pending.id;
    var slider = sliderOf(gallery);
    if (slider) {
      var left = slider.getBoundingClientRect().left;
      var best = null;
      var bestDistance = Infinity;
      Array.prototype.forEach.call(slider.querySelectorAll('[data-media-item-id]'), function (slide) {
        var distance = Math.abs(slide.getBoundingClientRect().left - left);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = slide;
        }
      });
      if (best) return best.getAttribute('data-media-item-id');
    }
    var visible = gallery.querySelector('.product__media .product__media-item:not(.hidden)[data-media-item-id]');
    if (visible) return visible.getAttribute('data-media-item-id');
    var active = gallery.querySelector('[data-product-thumbnail].active');
    return active ? active.getAttribute('data-thumbnail-id') : null;
  }

  function revealThumb(thumb) {
    var viewport = thumb.closest('[data-scroll-container-viewport]');
    var item = thumb.closest('li') || thumb;
    if (!viewport) return;
    var v = viewport.getBoundingClientRect();
    var r = item.getBoundingClientRect();
    if (r.left >= v.left && r.right <= v.right) return;
    viewport.scrollBy({ left: r.left - v.left - (v.width - r.width) / 2, behavior: 'smooth' });
  }

  function go(gallery, step) {
    var thumbs = thumbsOf(gallery);
    if (thumbs.length < 2) return;
    var id = currentMediaId(gallery);
    var index = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute('data-thumbnail-id') === id) {
        index = i;
        break;
      }
    }
    var target = thumbs[(index + step + thumbs.length) % thumbs.length];
    var targetId = target.getAttribute('data-thumbnail-id');
    var slider = sliderOf(gallery);
    var slide = slider && slideById(slider, targetId);
    if (slide) {
      gallery.__tujuPending = { id: targetId, until: Date.now() + PENDING_MS };
      slider.scrollTo({
        left: slide.getBoundingClientRect().left - slider.getBoundingClientRect().left + slider.scrollLeft,
        behavior: 'smooth'
      });
    } else {
      target.click();
    }
    revealThumb(target);
  }

  function button(gallery, direction) {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'tuju-gal-nav tuju-gal-nav--' + direction;
    el.setAttribute('aria-label', script.dataset[direction] || '');
    el.innerHTML = ICON;
    el.addEventListener('click', function () {
      go(gallery, direction === 'next' ? 1 : -1);
    });
    return el;
  }

  function counter(gallery, slider, total) {
    var el = document.createElement('span');
    el.className = 'tuju-gal-count';
    el.setAttribute('aria-hidden', 'true');
    var thumbs = thumbsOf(gallery);
    var frame = 0;
    function update() {
      frame = 0;
      var id = currentMediaId(gallery);
      var index = 0;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-thumbnail-id') === id) index = i;
      }
      el.textContent = (index + 1) + ' / ' + total;
    }
    slider.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame(update);
    }, { passive: true });
    update();
    return el;
  }

  function attach() {
    var badges = section.querySelector('template[data-tuju-gal-badges]');
    Array.prototype.forEach.call(section.querySelectorAll('.product__media-container'), function (gallery) {
      var media = gallery.querySelector('.product__media');
      if (!media) return;
      if (badges && !media.querySelector(':scope > .tuju-gal-badges')) {
        media.appendChild(badges.content.cloneNode(true));
      }
      var total = thumbsOf(gallery).length;
      if (total < 2 || media.querySelector(':scope > .tuju-gal-nav')) return;
      media.appendChild(button(gallery, 'prev'));
      media.appendChild(button(gallery, 'next'));
      var slider = sliderOf(gallery);
      if (slider) media.appendChild(counter(gallery, slider, total));
    });
  }

  attach();
  var left = section.querySelector('.product__primary-left');
  if (left && window.MutationObserver) new MutationObserver(attach).observe(left, { childList: true });
})();
